import { usePinnedPostsContext } from 'src/context/pinnedPosts'
import { RiPushpinFill } from '@remixicon/react'
import i18n from 'src/i18n'
import { FeedCard } from '../feedCard'

const PinnedPosts = () => {
  const { highLighted, pinnedPosts } = usePinnedPostsContext()

  const hasPinnedPosts = Array.isArray(highLighted) && highLighted.length > 0
  const pinnedPostsLength = pinnedPosts?.length

  if (!hasPinnedPosts) {
    return null
  }

  return (
    <div>
      <header className="_text-gray-900 _d-flex _align-items-center _pb-5">
        <RiPushpinFill size={24} className="_mr-3" />
        <h2 className="_text-3 _font-weight-extrabold">
          {i18n.t('feed.pinnedPosts.header.title')} <span>({pinnedPostsLength})</span>
        </h2>
      </header>

      {highLighted.map((post) => (
        <FeedCard key={post.id} post={post} highlight />
      ))}
    </div>
  )
}

export default PinnedPosts
